import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';

@Pipe({ name: 'playerPoints' })
export class PlayerPointsPipe implements PipeTransform {
    transform(value: number): number {
        return Math.round((value) * 100) / 100;
    }
}
